"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var actions_1 = require("../common/actions");
var _1 = require(".");
var ActionFactory = /** @class */ (function () {
    function ActionFactory(invitationService, notificationService) {
        this.invitationService = invitationService;
        this.notificationService = notificationService;
        this.actionsGenerator = new Map();
        this.initActionRegistry();
    }
    ActionFactory.prototype.initActionRegistry = function () {
        var _this = this;
        this.addAction('EnableChatButton', function () { return new actions_1.EnableButtonAction(_this.notificationService); });
        this.addAction('ShowProactiveChat', function () { return new actions_1.ShowProactiveChatAction(_this.invitationService, _this.notificationService); });
        this.addAction('CloseChatInvitation', function () { return new actions_1.CloseInvitationAction(_this.invitationService, _this.notificationService); });
    };
    ActionFactory.prototype.addAction = function (name, generator) {
        this.actionsGenerator.set(name, generator);
    };
    ActionFactory.prototype.getAction = function (name) {
        var generator = this.actionsGenerator.get(name);
        if (!generator)
            throw new Error("Unsupported action \"" + name + "\"");
        var action = generator();
        return action;
    };
    return ActionFactory;
}());
exports.ActionFactory = ActionFactory;
